
















































import { defineComponent, watch, toRefs, getCurrentInstance, computed } from '@vue/composition-api';

import { FilterIcon } from 'tdesign-icons-vue';
import { iteratee } from 'lodash';
import { string } from 'joi';
import Empty from '@/renderer/components/drawer/components/Empty/index.vue';
import DynamicItem from './DynamicItem.vue';
import dynamicHandler, { OptionType } from '../composition/dynamicHandler';

// 动态
export default defineComponent({
  name: 'Dynamics',
  components: { DynamicItem, Empty, FilterIcon },
  props: {
    selectedItem: {
      type: Object,
      default: () => null,
    },
    spaceId: {
      type: String,
      default: '',
    },
    buttonTitle: {
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    const { spaceId, selectedItem } = toRefs(props);
    const vm = getCurrentInstance()?.proxy || context.root;
    const route = vm.$route;
    const orgId = route.query.spaceOrgId || vm.$store.getters.orgId;
    const {
      methods: initMethods,
      filterOptions,
      filter,
      loading,
      dynamicList,
      curHasMore,
      moreLoading,
    } = dynamicHandler(spaceId, selectedItem, Number(orgId));

    const dropDownFilterOptions = computed(() =>
      filterOptions.map(item => {
        return {
          content: item.label,
          value: item.value,
        };
      }),
    );

    const didClickDropdownOption = (data: { value: OptionType }) => {
      initMethods.getData(data.value, false);
    };

    const methods = {
      didClickOperationButton() {
        context.emit('didClickOperationButton');
      },
    };

    watch(
      props,
      val => {
        initMethods.getData('week', true);
      },
      {
        immediate: true,
        deep: true,
      },
    );

    const scroll = (options: { e: Event | WheelEvent; scrollTop: number; scrollBottom: number }) => {
      if (moreLoading.value || !curHasMore.value) return;
      const { scrollBottom } = options;
      if (scrollBottom <= 20) {
        initMethods.pushDynamicList();
      }
    };
    return {
      scroll,
      filter,
      filterOptions,
      loading,
      dynamicList,
      initMethods,
      curHasMore,
      moreLoading,
      methods,
      dropDownFilterOptions,
      didClickDropdownOption,
    };
  },
});
